import { Component } from 'preact';
import { Button } from './ui';

interface State { error: Error | null; }

export class ErrorBoundary extends Component<{ children: any }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div class="error-banner">
          <strong>Erro:</strong> {this.state.error.message}
          <br />
          <Button variant="secondary" size="sm" style={{ marginTop: 8 }} onClick={() => this.setState({ error: null })}>
            Tentar novamente
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
